// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-m_ha","advertDetailParameterList__header":"c-m_hb","advertDetailParameterList__list":"c-m_hc"};